import { render, staticRenderFns } from "./incomeIndicatorsChart.vue?vue&type=template&id=4c2685fa&scoped=true"
import script from "./incomeIndicatorsChart.vue?vue&type=script&lang=js"
export * from "./incomeIndicatorsChart.vue?vue&type=script&lang=js"
import style0 from "./incomeIndicatorsChart.vue?vue&type=style&index=0&id=4c2685fa&prod&scoped=true&lang=scss"
import style1 from "./incomeIndicatorsChart.vue?vue&type=style&index=1&id=4c2685fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2685fa",
  null
  
)

export default component.exports